import { Component, OnInit, OnDestroy } from "@angular/core";
import { AutoPayRequestDialogComponent } from "../auto-pay-request-dialog/auto-pay-request-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApsService } from "src/app/services/aps.service";
import { CustomerService, CompanyService } from "src/app/services";
import { APSMaster, WebCustomer } from "src/app/models";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-auto-pay",
  templateUrl: "./auto-pay.component.html",
  styleUrls: ["./auto-pay.component.scss"],
})
export class AutoPayComponent implements OnInit, OnDestroy
{
  private availableBanksSubscription: Subscription;
  public availableBanks: APSMaster[];
  private availableCardsSubscription: Subscription;
  public availableCards: APSMaster[];
  customerSubscription: Subscription;



  customer: WebCustomer;

  constructor(public dialog: MatDialog, private apsService: ApsService, private customerService: CustomerService) { }
  ngOnInit(): void
  {
    this.availableBanksSubscription = this.apsService.availableBanks.subscribe(
      (banks) =>
      {
        this.availableBanks = banks;
      }
    );
    this.availableCardsSubscription = this.apsService.availableCards.subscribe(
      (cards) =>
      {
        this.availableCards = cards;
      }
    );
    this.customerSubscription = this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.customer = customer;
      });

  }


  public handleAddAutoPay(): void
  {
    this.dialog.open(AutoPayRequestDialogComponent, {
      width: "500px",
      maxHeight: "90%",
      maxWidth: "90%",
      disableClose: true,
    });

  }

  ngOnDestroy(): void
  {
    this.availableBanksSubscription.unsubscribe();
    this.availableCardsSubscription.unsubscribe();
    this.customerSubscription.unsubscribe();
  }
}
